var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusinessMessagesGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_26724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_26724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 25C8.5625 25 7.97396 24.7552 7.48438 24.2656C6.99479 23.776 6.75 23.1875 6.75 22.5V10.9375L3.46875 7.0625C3.36458 6.9375 3.29167 6.80729 3.25 6.67188C3.20833 6.53646 3.1875 6.39583 3.1875 6.25C3.1875 5.91667 3.30208 5.625 3.53125 5.375C3.76042 5.125 4.0625 5 4.4375 5H25.5C26.1875 5 26.776 5.24479 27.2656 5.73438C27.7552 6.22396 28 6.8125 28 7.5V22.5C28 23.1875 27.7552 23.776 27.2656 24.2656C26.776 24.7552 26.1875 25 25.5 25H9.25ZM17.75 18.75H21.75C22.1042 18.75 22.401 18.6302 22.6406 18.3906C22.8802 18.151 23 17.8542 23 17.5C23 17.1458 22.8802 16.849 22.6406 16.6094C22.401 16.3698 22.1042 16.25 21.75 16.25H14.7813C14.2188 16.25 13.8281 16.5052 13.6094 17.0156C13.3906 17.526 13.4792 17.9792 13.875 18.375L16.5 21C16.7292 21.2292 17.0208 21.3438 17.375 21.3438C17.7292 21.3438 18.0208 21.2292 18.25 21C18.4792 20.7708 18.5938 20.4792 18.5938 20.125C18.5938 19.7708 18.4792 19.4792 18.25 19.25L17.75 18.75ZM17 11.25H13C12.6458 11.25 12.349 11.3698 12.1094 11.6094C11.8698 11.849 11.75 12.1458 11.75 12.5C11.75 12.8542 11.8698 13.151 12.1094 13.3906C12.349 13.6302 12.6458 13.75 13 13.75H19.9688C20.5312 13.75 20.9219 13.4948 21.1406 12.9844C21.3594 12.474 21.2708 12.0208 20.875 11.625L18.25 9C18.0208 8.77083 17.7292 8.65625 17.375 8.65625C17.0208 8.65625 16.7292 8.77083 16.5 9C16.2708 9.22917 16.1562 9.52083 16.1562 9.875C16.1562 10.2292 16.2708 10.5208 16.5 10.75L17 11.25Z",
    fill: "#ADBBCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessMessagesGrey);
export default __webpack_public_path__ + "static/media/icon_business_messages_grey.8b36c475236d612eba03ac0bdab77d7f.svg";
export { ForwardRef as ReactComponent };